import {DashboardCard} from '../dashboard-card/DashboardCard'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {DashboardTherapistRehabilitationPieChart} from '../dashboard-therapist-rehabilitation-pie-chart/DashboardTherapistRehabilitationPieChart'
import {PieChartLegend, PieChartLegendData} from '../pie-chart-legend/PieChartLegend'
import {useTheme} from 'styled-components'
import {useGetDashboardConsultants} from '../../query/useGetDashboardConsultants'
import {useMemo} from 'react'
import {DashboardTherapistRehabilitationCardSkeleton} from './DashboardTherapistRehabilitationCardSkeleton'

export const DashboardTherapistRehabilitationCard = () => {
    const {t} = useTranslation()
    const {palette} = useTheme()
    const {data, isLoading} = useGetDashboardConsultants({
        fields: ['operativeConsultants']
    })

    const legendData: PieChartLegendData[] = useMemo(
        () => [
            {
                name: t('dashboard:therapist_domiciliary'),
                value: data?.operativeConsultants?.therapists.domiciliary,
                color: palette.purple[200]
            },
            {
                name: t('dashboard:therapist_outpatient'),
                value: data?.operativeConsultants?.therapists.outpatient,
                color: palette.purple[400]
            },
            {
                name: t('dashboard:therapist_outpatient_domiciliary'),
                value: data?.operativeConsultants?.therapists.outpatient_domiciliary,
                color: palette.purple[800]
            }
        ],
        [data]
    )

    const totalTherapists = useMemo(() => {
        return (
            (data?.operativeConsultants?.therapists.domiciliary ?? 0) +
            (data?.operativeConsultants?.therapists.outpatient ?? 0) +
            (data?.operativeConsultants?.therapists.outpatient_domiciliary ?? 0)
        )
    }, [data])

    if (isLoading) {
        return <DashboardTherapistRehabilitationCardSkeleton />
    }

    return (
        <DashboardCard title={t('dashboard:therapist_rehabilitation')}>
            <Grid columns={2} gap={2}>
                <Flexbox direction="column" gap={4}>
                    <Text palette="neutral" shade="900" size="displaySm" weight={700}>
                        {totalTherapists}
                    </Text>

                    <PieChartLegend data={legendData} size="sm" />
                </Flexbox>
                <DashboardTherapistRehabilitationPieChart />
            </Grid>
        </DashboardCard>
    )
}
